import {
  LlmOutputTypesLookup,
  WorkerStatusTypesEnum,
  WorkerStatusTypesLookup,
} from '@eluve/graphql-types';

export type SummarizationStatusResult = {
  isSummarizing: boolean;
  isDataUploading: boolean;
  latestSummaryStatus?: WorkerStatusTypesEnum;
  latestSummaryJobCreatedAt?: string;
};

/**
 * Checks if an appointment is currently in a summarization state.
 *
 * An appointment is considered "summarizing" if:
 * 1. The database computed field indicates summarization in progress, OR
 * 2. The latest SOAP_NOTE job status is IN_PROGRESS or PENDING_DATA_UPLOAD
 *
 * @param isSummarizationInProgress - Database computed field value
 * @param appointmentLlmJobs - Array of LLM jobs for the appointment
 */
export const checkSummarizationStatus = (
  isSummarizationInProgress: boolean | null | undefined,
  appointmentLlmJobs: {
    jobStatus: WorkerStatusTypesEnum;
    llmOutputType: string;
    createdAt?: string | null;
  }[],
): SummarizationStatusResult => {
  const summaryJob = appointmentLlmJobs.find(
    (job) => job.llmOutputType === LlmOutputTypesLookup.SOAP_NOTE,
  );
  const latestSummaryStatus = summaryJob?.jobStatus;
  const latestSummaryJobCreatedAt = summaryJob?.createdAt ?? undefined;

  const isSummarizing =
    isSummarizationInProgress ||
    latestSummaryStatus === WorkerStatusTypesLookup.IN_PROGRESS;

  const isDataUploading =
    latestSummaryStatus === WorkerStatusTypesLookup.PENDING_DATA_UPLOAD;
  return {
    isSummarizing,
    isDataUploading,
    latestSummaryStatus,
    latestSummaryJobCreatedAt,
  };
};
